import { render, staticRenderFns } from "./centro-de-ayuda.vue?vue&type=template&id=585fdcba&scoped=true&"
import script from "./centro-de-ayuda.vue?vue&type=script&lang=js&"
export * from "./centro-de-ayuda.vue?vue&type=script&lang=js&"
import style0 from "./centro-de-ayuda.vue?vue&type=style&index=0&id=585fdcba&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585fdcba",
  null
  
)

export default component.exports